<template>
  <div
    class="app-main-inner sop-template-form"
    style="display: flex;height: 100%;"
  >
    <div class="app-main-inner-row">
      <el-card class="box-card form-column" style="height: 100%;width: 840px;display: flex;">
        <div style="display: flex">
          <div class="form-column" style="margin-right: 30px">
            <el-form :disabled="readOnly" label-position="left" label-width="100px" style="width: 360px; margin-right: 10px;">
              <span class="title">{{ $t('CargoMsg.Cargo_SetUpSopTemplateApplicationBusinessScenarios') }}</span>
              <el-form-item :label="$t('Pricing.FeeIndex')">
                <div style="display: flex">
                  <el-input
                    v-model="form.serialNumber"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                  />
                  <el-checkbox v-model="form.displayOnTheHomepage" style="margin-left: 10px">{{ $t('CargoMsg.Cargo_TheHomePageIsDisplayed') }}</el-checkbox>
                </div>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_SopTemplateName')">
                <el-input v-model="form.templateName" />
              </el-form-item>
              <el-form-item :label="containerLoadTypeName">
                <cargo-advance-select
                  :static-options="fLclType"
                  :placeholder="selectPlaceholder"
                  :cache="false"
                  :default-multiple-value="containerLoadTypeArray"
                  filterable
                  multiple
                  clearable
                  tag-value="code"
                  @parentCallBack="p=>{containerLoadTypeArray=p.value; changeTheSpellingType()}"
                />
              </el-form-item>
              <el-form-item v-if="form.lob === 'IE'" :label="$t('SeaExport.OperateType')">
                <cargo-advance-select
                  ref="operateType"
                  no="operateType"
                  filterable
                  clearable
                  multiple
                  :static-options="operateTypes"
                  :placeholder="selectPlaceholder"
                  :default-multiple-value="operateTypeArray"
                  :tag-name="isZh?'chineseName':'englishName'"
                  tag-value="code"
                  @parentCallBack="p=>{operateTypeArray=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_CustomJobType')">
                <cargo-advance-select
                  ref="customJobType"
                  no="customJobType"
                  :static-options="customJobType"
                  filterable
                  clearable
                  multiple
                  :placeholder="selectPlaceholder"
                  :default-multiple-value="customJobTypeArray"
                  :tag-name="isZh?'name':'englishName'"
                  tag-value="code"
                  @parentCallBack="p=>{customJobTypeArray=p.value}"
                />
              </el-form-item>
              <el-form-item v-show="isSea || form.lob === 'AI'" :label="form.lob === 'AI' ? $t('SeaExport.TransportationClause') : $t('SeaExport.MBLTransportationClause')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_ShippingTerm"
                  filterable
                  :placeholder="selectPlaceholder"
                  multiple
                  clearable
                  :default-value="form.freightTerm"
                  :default-multiple-value="freightTermArray"
                  @parentCallBack="p=>{freightTermArray=p.value}"
                />
              </el-form-item>
              <el-form-item v-show="isSea" :label="$t('SeaExport.HBLTransportationClause')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_ShippingTerm"
                  filterable
                  clearable
                  :placeholder="selectPlaceholder"
                  multiple
                  :default-multiple-value="freightTermHBLArray"
                  @parentCallBack="p=>{freightTermHBLArray=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.CargoType')">
                <cargo-advance-select
                  no="cargoType"
                  clearable
                  :placeholder="selectPlaceholder"
                  :select-type="selectTypeNames.basic_data_CargoType"
                  :method-params="cargoTypeMethodParams"
                  filterable
                  multiple
                  :default-multiple-value="cargoTypeArray"
                  :callback-params="form.lob === 'SI' ? {key:'cargoType'} : null"
                  @parentCallBack="p=>{cargoTypeArray=p.value}"
                />
              </el-form-item>
              <el-form-item v-if="form.lob === 'SE'" :label="$t('CargoMsg.Cargo_IsSoc')">
                <el-select
                  v-model="form.soc"
                  no="soc"
                  clearable
                  :placeholder="selectPlaceholder"
                  size="mini"
                >
                  <el-option :label="$t('Message.Yes')" :value="true" />
                  <el-option :label="$t('Message.No')" :value="false" />
                </el-select>
              </el-form-item>
              <el-form-item v-if="form.lob !== 'IE'" :label="$t('SeaExport.LocalService')">
                <el-checkbox v-model="notLocalService">{{ $t('SeaExport.NotLocalService') }}</el-checkbox>
                <cargo-advance-select
                  :disabled="notLocalService"
                  filterable
                  clearable
                  :placeholder="selectPlaceholder"
                  multiple
                  clear-not-match
                  tag-value="code"
                  :static-options="localServices"
                  :default-multiple-value="localServiceArray"
                  @parentCallBack="p=>{localServiceArray=p.value}"
                />
              </el-form-item>
              <el-form-item v-if="form.lob === 'SE'" :label="$t('CargoMsg.Cargo_DestinationAgent')">
                <el-checkbox v-model="notDestinationAgent">{{ $t('CargoMsg.Cargo_None') + $t('CargoMsg.Cargo_DestinationAgent') }}</el-checkbox>
                <cargo-advance-select
                  :disabled="notDestinationAgent"
                  filterable
                  clearable
                  :placeholder="selectPlaceholder"
                  multiple
                  clear-not-match
                  tag-value="code"
                  :static-options="destinationAgents"
                  :default-multiple-value="destinationAgentArray"
                  @parentCallBack="p=>{destinationAgentArray=p.value}"
                />
              </el-form-item>
              <el-form-item v-if="form.lob === 'SI'" :label="$t('SeaImport.ChangeOrders')">
                <el-select
                  v-model="form.trans"
                  no="trans"
                  clearable
                  :placeholder="selectPlaceholder"
                  size="mini"
                >
                  <el-option :label="$t('CargoMsg.Need')" :value="true" />
                  <el-option :label="$t('CargoMsg.NoNeed')" :value="false" />
                </el-select>
              </el-form-item>
              <el-form-item v-if="form.lob === 'AE'" :label="$t('SeaExport.CustomsDeclarationType')">
                <cargo-advance-select
                  no="customsClaim"
                  :select-type="selectTypeNames.local_cache_AirExportConstants$CUSTOM_CLAIMS2"
                  filterable
                  clearable
                  multiple
                  :default-multiple-value="customsClaimArray"
                  :placeholder="selectPlaceholder"
                  @parentCallBack="p=>{customsClaimArray=p.value}"
                />
              </el-form-item>
              <el-form-item v-if="form.lob !== 'AE'" :label="$t('SeaExport.CustomsDeclaration')">
                <cargo-advance-select
                  no="customs"
                  :static-options="needList"
                  filterable
                  clearable
                  :placeholder="selectPlaceholder"
                  tag-value="code"
                  :default-value="form.customs"
                  @parentCallBack="p=>{form.customs=p.value}"
                />
              </el-form-item>
              <el-form-item v-if="form.lob === 'AE'" :label="$t('AirExport.CustomsDeclarationMethod')">
                <cargo-advance-select
                  no="customsMethod"
                  filterable
                  :select-type="selectTypeNames.local_cache_AirExportConstants$CUSTOM_CLAIMS"
                  :default-multiple-value="customsMethodArray"
                  :tag-name="isZh?'chineseName':'englishName'"
                  :fields="['chineseName']"
                  :placeholder="selectPlaceholder"
                  multiple
                  @parentCallBack="p=>{customsMethodArray=p.value}"
                />
              </el-form-item>
              <el-form-item v-if="form.lob === 'AE'" :label="$t('SeaExport.BookingProperty')">
                <cargo-advance-select
                  no="bookingTerm"
                  :select-type="selectTypeNames.local_cache_BookingTerm"
                  filterable
                  clearable
                  multiple
                  :default-multiple-value="bookingTermArray"
                  :placeholder="selectPlaceholder"
                  :fields="['chineseName']"
                  @parentCallBack="p=>{bookingTermArray=p.value}"
                />
              </el-form-item>
              <el-form-item v-show="form.lob === 'SE'" :label="$t('SeaExport.Anti_terrorismShipping')">
                <cargo-advance-select
                  no="customs"
                  :static-options="needList"
                  filterable
                  tag-value="code"
                  :placeholder="selectPlaceholder"
                  clearable
                  :default-value="form.ams"
                  @parentCallBack="p=>{form.ams=p.value}"
                />
              </el-form-item>
              <el-form-item v-show="form.lob === 'SE'" :label="$t('SeaExport.SolicitationType')">
                <el-select
                  v-model="form.cargoSource"
                  no="cargoSource"
                  clearable
                  :placeholder="selectPlaceholder"
                  size="mini"
                >
                  <el-option
                    v-for="(item,index) in CARGO_SOURCES"
                    :key="index"
                    :label="isZh?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>&nbsp;
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_ApplicationBranch')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Office"
                  filterable
                  multiple
                  :placeholder="selectPlaceholder"
                  clearable
                  :default-multiple-value="officeArray"
                  @parentCallBack="onOfficeChange"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_ApplicationDepartment')">
                <cargo-advance-select
                  filterable
                  multiple
                  :placeholder="selectPlaceholder"
                  clearable
                  :static-options="departmentList"
                  tag-value="departmentId"
                  :default-multiple-value="departmentArray"
                  @parentCallBack="onDepartmentChange"
                />
              </el-form-item>
              <el-form-item v-if="form.lob === 'SE'" :label="$t('CargoMsg.Cargo_IsTransfer')">
                <el-select
                  v-model="form.transfering"
                  no="transfering"
                  clearable
                  :placeholder="selectPlaceholder"
                  size="mini"
                >
                  <el-option :label="$t('Message.Yes')" :value="true" />
                  <el-option :label="$t('Message.No')" :value="false" />
                </el-select>
              </el-form-item>
              <el-form v-show="form.lob === 'SE'" label-position="left" label-width="100px" style="width: 360px; margin-right: 10px;">
                <el-form-item :label="$t('CargoMsg.Cargo_MoreBusinessConditions')">
                  <el-button type="primary" @click="showMoreConditionDialog.visible=true">{{ $t('CargoMsg.Cargo_MoreConditionsOptions') }}</el-button>
                </el-form-item>
              </el-form>
              <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
                <el-input
                  v-model="form.remark"
                  type="textarea"
                  :rows="3"
                />
              </el-form-item>
              <div style="margin-top: 20px; margin-bottom: 20px;">
                <span>{{ $t('SystemMaintenance.DropThisConditionForGoods') }}</span>
              </div>
            </el-form>
          </div>
          <div class="form-column">
            <el-form :disabled="readOnly" label-position="right" label-width="110px" style="width: 420px;">
              <span class="title">{{ $t('CargoMsg.Cargo_QuicklySelectBusinessNodes') }}</span>
              <el-checkbox-group v-model="form.chooseNodeCode" class="checkboxGroup">
                <el-row>
                  <el-col v-for="(item, index) in platformTracking" :key="index" :span="isZh?6:8" style="margin-top:2px">
                    <el-checkbox :label="item.code" :title="item.level + `.` + (isZh ? item.codeCname : item.codeEname)" @change="checked => changeNodeCode(checked, item)">{{ item.level + `.` + (isZh ? item.codeCname : item.codeEname) }}</el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>
              <div v-if="false">
                <span v-show="form.lob === 'SE'" class="title" style="margin-top: 20px">{{ $t('CargoMsg.Cargo_QuicklyConfigureDataServices') }}</span>
                <i v-show="form.lob === 'SE'" class="el-icon-info" style="color:#1F75D5; font-size: 16px; margin-left: 5px" @click="learnMore" />
                <div v-show="form.lob === 'SE'" style="display: flex">
                  <el-checkbox-group v-model="form.chooseNodeStatusCode">
                    <el-form-item :label="$t('CargoMsg.Cargo_ShipPlanningAtThePortOfDeparture')">
                      <el-checkbox v-for="(item, index) in shipPlannings" :key="index" :label="item.code" @change="checked => changeStatusCode(checked, item)">{{ isZh ? item.fieldName : item.fieldEname }}</el-checkbox>
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_ContainerTracking')">
                      <el-checkbox v-for="(item, index) in containerTracking" :key="index" :label="item.code" @change="checked => changeStatusCode(checked, item)">{{ isZh ? item.fieldName : item.fieldEname }}</el-checkbox>
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_ShipDynamicsAtThePortOfDestination')">
                      <el-checkbox v-for="(item, index) in shipDynamics" :key="index" :label="item.code" @change="checked => changeStatusCode(checked, item)">{{ isZh ? item.fieldName : item.fieldEname }}</el-checkbox>
                    </el-form-item>
                  </el-checkbox-group>
                </div>
              </div>
              <span class="title" style="margin-top: 20px">{{ $t('CargoMsg.Cargo_SetTheNotificationRecipients') }}</span>

              <template v-if="!!form.innerConfig">
                <el-checkbox v-model="form.innerConfig.post" style="width: 100%;">{{ $t('CargoMsg.Cargo_DesignatedPost') }}</el-checkbox>
                <div style="margin-left: 15px;">
                  <el-checkbox v-model="form.innerConfig.sales" :disabled="!form.innerConfig.post">{{ $t('CargoMsg.Cargo_Sales') }}</el-checkbox>
                  <el-checkbox v-model="form.innerConfig.op" :disabled="!form.innerConfig.post">{{ $t('CargoMsg.Cargo_Operation') }}</el-checkbox>
                  <el-checkbox v-model="form.innerConfig.csr" :disabled="!form.innerConfig.post">{{ $t('CargoMsg.Cargo_CustomerService') }}</el-checkbox>

                  <el-checkbox v-model="form.innerConfig.overseaOp" :disabled="!form.innerConfig.post">{{ $t('SeaExport.OverseaCustomerService') }}</el-checkbox>
                  <el-checkbox v-model="form.innerConfig.dc" :disabled="!form.innerConfig.post">{{ $t('SeaExport.Documents') }}</el-checkbox>
                  <el-checkbox v-model="form.innerConfig.planner" :disabled="!form.innerConfig.post">{{ $t('SeaExport.AirlinePerson2') }}</el-checkbox>
                  <el-checkbox v-model="form.innerConfig.cargoSales" :disabled="!form.innerConfig.post">{{ $t('SeaExport.SalesOfGoods') }}</el-checkbox>
                  <el-checkbox v-model="form.innerConfig.siteOp" :disabled="!form.innerConfig.post">{{ $t('SeaExport.FieldOperation') }}</el-checkbox>
                  <el-checkbox v-model="form.innerConfig.userDefinedRoleId1" :disabled="!form.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole1') }}</el-checkbox>
                  <el-checkbox v-model="form.innerConfig.userDefinedRoleId2" :disabled="!form.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole2') }}</el-checkbox>
                  <el-checkbox v-model="form.innerConfig.userDefinedRoleId3" :disabled="!form.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole3') }}</el-checkbox>
                  <el-checkbox v-model="form.innerConfig.userDefinedRoleId4" :disabled="!form.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole4') }}</el-checkbox>
                  <el-checkbox v-model="form.innerConfig.userDefinedRoleId5" :disabled="!form.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole5') }}</el-checkbox>
                  <el-checkbox v-model="form.innerConfig.userDefinedRoleId6" :disabled="!form.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole6') }}</el-checkbox>
                  <el-checkbox v-model="form.innerConfig.userDefinedRoleId7" :disabled="!form.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole7') }}</el-checkbox>
                  <el-checkbox v-model="form.innerConfig.userDefinedRoleId8" :disabled="!form.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole8') }}</el-checkbox>
                </div>
                <el-checkbox v-model="form.innerConfig.personnel" style="width: 100%;" @change="form.innerConfig.userList=[]">{{ $t('CargoMsg.Cargo_DesignatedPersonnel') }}</el-checkbox>

                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_User"
                  :fields="['chineseName']"
                  :disabled="!form.innerConfig.personnel"
                  :placeholder="selectPlaceholder"
                  :callback-params="{key:'userList'}"
                  callback-method-type="value"
                  tag-value="userId"
                  tag-name="chineseName"
                  :filter-tag-names="['chineseName']"
                  :method-params="{pageSize: 1000000, active: true, hasRole: true}"
                  :default-multiple-value="form.innerConfig.userList"
                  multiple
                  filterable
                  style="width:205px;"
                  options-width="230px"
                  @parentCallBack="getInnerConfigValueFromChild"
                />
                <span class="title" style="margin-top: 20px;width: 100%;">{{ $t('CargoMsg.Cargo_ReminderMethod') }}</span>
                <el-checkbox v-model="form.innerConfig.email">{{ $t('Viewer.email') }}</el-checkbox>
                <el-checkbox v-model="form.innerConfig.weChat">{{ $t('CargoMsg.Cargo_Wechat') }}</el-checkbox>
                <el-checkbox v-model="form.innerConfig.bellMsg">{{ $t('Message.Message') }}</el-checkbox>
              </template>
              <span class="title" style="margin-top: 20px;width: 100%;">{{ $t('CargoMsg.Cargo_TemplateNodeWorkTaskSetting') }}</span>
              <el-checkbox v-model="form.workTaskEnable">{{ $t('CargoMsg.Cargo_WorkTaskEnable') }}</el-checkbox>
              <span class="title" style="margin-top: 20px;width: 100%;">{{ $t('SystemMaintenance.SOPRestrictionsForBusinessDocuments') }}</span>
              <el-checkbox v-model="form.onlyApplyBranchAndHq" :disabled="!officeArray || officeArray.length === 0">{{ $t('SystemMaintenance.OnlyForTheBranchTemplate') }}</el-checkbox>
              <el-checkbox v-model="form.onlyApplyDepartmentAndHq" :disabled="!departmentArray || departmentArray.length === 0">{{ $t('SystemMaintenance.OnlyOperationDepartmentAndTemplate') }}</el-checkbox>
            </el-form>
          </div>
        </div>
      </el-card>
    </div>
    <cargo-multi-condition-tab
      v-if="showMoreConditionDialog.visible"
      :visible="showMoreConditionDialog.visible"
      :title="$t('CargoMsg.Cargo_BusinessConditionsOptions')"
      config-module="71040402"
      :detail-value="form.moreConditions"
      :readonly="readOnly"
      @change="changeMoreConditions"
      @close="showMoreConditionDialog.visible=false"
    />
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as AirExportConstans from '@/class/cargo/model/parameters/AirExportConstants'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as SopConstants from '@/class/cargo/model/parameters/SopConstants'
import CargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import * as commonUtil from '@/utils/commonUtil'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import { cacheKeys, getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import CargoMultiConditionTab
  from '@/components/Cargo/Common/cargoMultiConditionTab'
import { CARGO_SOURCES } from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { OPERATE_TYPES } from '@/class/cargo/model/parameters/ContainerLoadType'

export default {
  name: 'SopTemplateForm',
  components: { CargoMultiConditionTab, CargoOfficeSelect, CargoAdvanceSelect },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    platformData: { // 平台模板数据
      type: Object,
      default: () => {}
    },
    openSubscribe: { // 是否开通港区服务
      type: Boolean,
      default: () => false
    },
    opStatus: { type: String, default: '' } // 操作状态：add|edit|read
  },
  data() {
    return {
      CARGO_SOURCES,
      selectTypeNames: TYPE_NAMES,
      platformTracking: [], // 平台的节点列表
      platformTrackingDetails: [], // 平台的节点状态列表
      nodeWithStateCodes: {}, // 节点code对应状态code列表
      stateWithNodeCodes: {}, // 状态code对应节点code
      localServiceArray: [],
      destinationAgentArray: [],
      customsClaimArray: [],
      customsMethodArray: [],
      bookingTermArray: [],
      cargoTypeArray: [],
      containerLoadTypeArray: [],
      operateTypeArray: [],
      customJobTypeArray: [],
      freightTermArray: [],
      freightTermHBLArray: [],
      officeArray: [],
      departmentArray: [],
      departmentList: [],
      needList: SystemConstants.NEEDS,
      notLocalService: false,
      notDestinationAgent: false,
      allOfficeList: [],
      allDepartments: [],
      showMoreConditionDialog: {
        visible: false
      }
    }
  },
  computed: {
    isNew() {
      return this.opStatus === 'add'
    },
    isEdit() {
      return this.opStatus === 'edit'
    },
    readOnly() {
      return this.opStatus === 'read'
    },
    fLclType() {
      const lob = this.form.lob
      if (!lob) {
        return []
      }
      return SopUtil.getFLclType(lob)
    },
    customJobType() {
      return ColumnUtils.getBasicDataCacheList(cacheKeys.basic_data_CutomJobType, (item) => this.customJobTypeFilter(item))
    },
    operateTypes() {
      return OPERATE_TYPES
    },
    cargoTypeMethodParams() {
      const lob = this.form.lob
      if (lob === 'SE' || lob === 'RE') {
        return { sea: true }
      }
      if (lob === 'AE' || lob === 'AI') {
        return { air: true }
      }
      return {}
    },
    destinationAgents() {
      return SeaExportConstants.DESTINATION_TYPES
    },
    localServices() {
      const lob = this.form.lob
      if (lob === 'AE') {
        return AirExportConstans.SUFFY_TYPES
      }
      if (lob === 'SE') {
        return SeaExportConstants.SOP_STUFFY_TYPES
      }
      if (lob === 'SI') {
        return SeaExportConstants.SOP_STUFFY_TYPES
      }
      if (lob === 'AI') {
        return SopConstants.AI_SUFFY_TYPES
      }
      if (lob === 'RE') {
        return SopConstants.RE_SUFFY_TYPES
      }
      if (lob === 'RI') {
        return SopConstants.RE_SUFFY_TYPES
      }
      return []
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    shipPlannings() {
      return this.getDataServiceList(SopConstants.DATA_SERVICE_SHIP_PLANNING.code)
    },
    containerTracking() {
      return this.getDataServiceList(SopConstants.DATA_SERVICE_CONTAINER_TRACKING.code)
    },
    shipDynamics() {
      return this.getDataServiceList(SopConstants.DATA_SERVICE_SHIP_DYNAMICS.code)
    },
    containerLoadTypeName() {
      if (this.isAir) {
        return this.$t('SeaExport.OperateType')
      }
      return this.$t('CargoMsg.Cargo_FLCLType')
    },
    isAir() {
      return this.form.lob === 'AE' || this.form.lob === 'AI'
    },
    isSea() {
      return this.form.lob === 'SE' || this.form.lob === 'SI'
    },
    selectPlaceholder() {
      return this.readOnly ? ' ' : this.$t('Message.PleaseSelect')
    },
    isPlatform() {
      return this.$store.getters.tenantId === 1
    }
  },
  watch: {
    localServiceArray(newVal) {
      this.form.localService = this.notLocalService ? 'notLocalService' : newVal.join(',')
    },
    destinationAgentArray(newVal) {
      this.form.destinationAgent = this.notDestinationAgent ? 'notDestinationAgent' : ''
      this.form.destinationAgentList = this.notDestinationAgent ? [] : newVal
    },
    customsClaimArray(newVal) {
      this.form.customsClaim = newVal.join(',')
    },
    customsMethodArray(newVal) {
      this.form.customsMethod = newVal.join(',')
    },
    bookingTermArray(newVal) {
      this.form.bookingTerm = newVal.join(',')
    },
    cargoTypeArray(newVal) {
      this.form.cargoType = newVal.join(',')
    },
    containerLoadTypeArray(newVal) {
      this.form.containerLoadType = newVal.join(',')
    },
    customJobTypeArray(newVal) {
      this.form.customJobType = newVal.join(',')
    },
    operateTypeArray(newVal) {
      this.form.operateType = newVal.join(',')
    },
    freightTermArray(newVal) {
      this.form.freightTerm = newVal.join(',')
    },
    freightTermHBLArray(newVal) {
      this.form.freightTermHbl = newVal.join(',')
    },
    officeArray(newVal) {
      const offices = newVal.join(',')
      this.form.branch = offices
      if (offices) {
        // 处理部门选项
        const officeList = this.allOfficeList.filter(p => newVal.indexOf(p.officeId) > -1)
        const officeKeys = officeList.map(item => item.uuid)
        const departmentList = this.allDepartments.filter(p => officeKeys.indexOf(p.officeUuid) > -1)
        if (departmentList && departmentList.length > 0 && this.departmentArray && this.departmentArray.length > 0) {
          const departmentIds = departmentList.map(item => item.departmentId)
          // 不在的部门要移除
          this.departmentArray = this.departmentArray.filter(item => departmentIds.indexOf(item) > -1)
        }
        this.departmentList = departmentList
      } else {
        this.departmentList = []
        this.departmentArray = []
      }
    },
    departmentArray(newVal) {
      this.form.department = newVal.join(',')
    },
    notLocalService(newVal) {
      if (newVal) {
        this.localServiceArray = ['notLocalService']
      } else {
        this.localServiceArray = []
      }
    },
    notDestinationAgent(newVal) {
      if (newVal) {
        this.destinationAgentArray = ['notDestinationAgent']
      } else {
        this.destinationAgentArray = []
      }
    },
    'form.innerConfig.post': function(val) {
      if (!val && this.form.innerConfig instanceof Object) {
        this.form.innerConfig.sales = false
        this.form.innerConfig.overseaOp = false
        this.form.innerConfig.dc = false
        this.form.innerConfig.planner = false
        this.form.innerConfig.op = false
        this.form.innerConfig.csr = false
        this.form.innerConfig.siteOp = false
        this.form.innerConfig.userDefinedRoleId1 = false
        this.form.innerConfig.userDefinedRoleId2 = false
        this.form.innerConfig.userDefinedRoleId3 = false
        this.form.innerConfig.userDefinedRoleId4 = false
        this.form.innerConfig.userDefinedRoleId5 = false
        this.form.innerConfig.userDefinedRoleId6 = false
        this.form.innerConfig.userDefinedRoleId7 = false
        this.form.innerConfig.userDefinedRoleId8 = false
      }
    }
  },
  methods: {
    init() {
      if (this.isPlatform) {
        return
      }

      this.allOfficeList = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
      this.allDepartments = getCacheListByKey(basicCacheKeys.basic_data_Department_All)
      const platformData = this.platformData[this.form.lob]
      const trackingList = platformData.trackingList
      this.platformTrackingDetails = platformData.trackingDetails
      this.stateWithNodeCodes = platformData.stateWithNodeCodes
      this.nodeWithStateCodes = platformData.nodeWithStateCodes
      if (this.isNew) {
        const chooseNodeCode = []
        for (const data of trackingList) {
          if (data.quickConfiguration) {
            chooseNodeCode.push(data.code)
          }
        }
        this.form.chooseNodeCode = chooseNodeCode
      }
      this.form.stateWithNodeCodes = this.stateWithNodeCodes
      this.form.nodeWithStateCodes = this.nodeWithStateCodes
      this.platformTracking = trackingList
    },
    onShow() {
      this.init()
      this.notLocalService = this.form.localService === 'notLocalService'
      this.notDestinationAgent = this.form.destinationAgent === 'notDestinationAgent'
      this.localServiceArray = this.form.localService ? this.form.localService.split(',') : []
      this.destinationAgentArray = this.form.destinationAgent ? this.form.destinationAgent.split(',') : []
      this.customsClaimArray = this.form.customsClaim ? this.form.customsClaim.split(',').map(item => Number(item)) : []
      this.customsMethodArray = this.form.customsMethod ? this.form.customsMethod.split(',').map(item => Number(item)) : []
      this.bookingTermArray = this.form.bookingTerm ? this.form.bookingTerm.split(',').map(item => item) : []
      this.cargoTypeArray = this.form.cargoType ? this.form.cargoType.split(',') : []
      this.containerLoadTypeArray = commonUtil.split(this.form.containerLoadType, ',', this.isAir)
      this.freightTermArray = this.form.freightTerm ? this.form.freightTerm.split(',') : []
      this.freightTermHBLArray = this.form.freightTermHbl ? this.form.freightTermHbl.split(',') : []
      this.officeArray = this.form.branch ? this.form.branch.split(',').map(item => Number(item)) : []
      this.departmentArray = this.form.department ? this.form.department.split(',').map(item => Number(item)) : []
      this.customJobTypeArray = this.form.customJobType ? this.form.customJobType.split(',') : []
      this.operateTypeArray = this.form.operateType ? this.form.operateType.split(',') : []
      if (this.form && this.form.innerConfig && !(this.form.innerConfig instanceof Object)) {
        this.form.innerConfig = JSON.parse(this.form.innerConfig)
        this.form.innerConfig.userList = this.form.innerConfig.userList ? this.form.innerConfig.userList.split(',').map(item => Number(item)) : []
      }
      if (!this.form.innerConfig) {
        this.form.innerConfig = {
          sales: false,
          overseaOp: false,
          dc: false,
          planner: false,
          op: false,
          csr: false,
          post: false,
          personnel: false,
          siteOp: false,
          userDefinedRoleId1: false, // 自定义岗位1
          userDefinedRoleId2: false, // 自定义岗位2
          userDefinedRoleId3: false, // 自定义岗位3
          userDefinedRoleId4: false, // 自定义岗位4
          userDefinedRoleId5: false, // 自定义岗位5
          userDefinedRoleId6: false, // 自定义岗位6
          userDefinedRoleId7: false, // 自定义岗位7
          userDefinedRoleId8: false, // 自定义岗位8
          userList: [], // 用户id逗号隔开
          email: false,
          stationNotice: false,
          weChat: false,
          bellMsg: false
        }
      }
    },
    cancel() {
      this.initForm()
    },
    getInnerConfigValueFromChild(obj) {
      this.form.innerConfig[obj.key] = obj.value
    },
    getDataServiceList(dataService) {
      if (!this.platformTrackingDetails || this.platformTrackingDetails.length === 0) {
        return []
      }
      return this.platformTrackingDetails.filter(item => item.dataService === dataService) || []
    },
    changeNodeCode(checked, data) {
      // 取消选中时、若节点存在数据服务的节点状态，需处理同步取消数据服务节点状态的选中
      if (!checked && this.nodeWithStateCodes.hasOwnProperty(data.code)) {
        const chooseNodeStatusCode = this.form.chooseNodeStatusCode
        // 数据服务不为空
        if (chooseNodeStatusCode && chooseNodeStatusCode.length > 0) {
          const statusCodes = this.nodeWithStateCodes[data.code]
          for (const statusCode of statusCodes) {
            // 找到对应的状态选中项，去掉勾选
            const index = chooseNodeStatusCode.findIndex(p => p === statusCode)
            if (index > -1) {
              chooseNodeStatusCode.splice(index, 1)
            }
          }
        }
      }
    },
    changeStatusCode(checked, data) {
      const sopOpenSubscribe = LocalStorageUtils.getConfiguration('sopOpenSubscribe')
      if (!this.openSubscribe && !sopOpenSubscribe) {
        LocalStorageUtils.setConfiguration('sopOpenSubscribe', true)
        // 不开启且未提醒时，需要提醒
        this.learnMore()
      }
      // 选中数据服务时，若对应的节点未被选中，则要选中对应的节点
      if (checked && this.stateWithNodeCodes.hasOwnProperty(data.code)) {
        const nodeCode = this.stateWithNodeCodes[data.code]
        const index = this.form.chooseNodeCode.findIndex(p => p === nodeCode)
        if (index === -1) {
          this.form.chooseNodeCode.push(nodeCode)
        }
      }
    },
    learnMore() {
      const h = this.$createElement
      this.$msgbox({
        message: h('div', { class: 'reminder-form' }, [
          h('i', { class: 'el-icon-warning' }, ''),
          h('span', { class: 'warning-title' }, this.$t('BusinessIntelligence.businessIntelligenceChart.warmPrompt')),
          h('p', null, this.$t('CargoMsg.Cargo_AskSopDataService')),
          h('a', { attrs: { href: 'https://mp.weixin.qq.com/s/eUJYKQJS5nJvVnjogguW8w', target: '_blank' }}, 'https://mp.weixin.qq.com/s/eUJYKQJS5nJvVnjogguW8w'),
          h('p', null, this.$t('CargoMsg.Cargo_ContactDataServiceReminder'))
        ]),
        showCancelButton: false,
        confirmButtonText: this.$t('Message.GotIt')
      }).then(() => {
      })
    },
    changeMoreConditions(data) {
      this.form.moreConditions = data
      this.showMoreConditionDialog.visible = false
    },
    customJobTypeFilter(item) {
      if (item && item.type === this.form.lob && item.active) {
        if (this.containerLoadTypeArray && this.containerLoadTypeArray.length > 0) {
          // 业务模式不为空时，需要判断当前业务模式是否包含自定义业务类型的业务模式
          if (item.containerLoadType) {
            for (const containerLoadType of this.containerLoadTypeArray) {
              if (containerLoadType.toString() === item.containerLoadType.toString()) {
                return true
              }
            }
          } else {
            return true
          }
        } else {
          // 业务模式为空时，直接返回true
          return true
        }
      }
      return false
    },
    changeTheSpellingType() {
      if (this.containerLoadTypeArray.length === 0) {
        this.customJobTypeArray = []
      } else {
        if (this.customJobTypeArray && this.customJobTypeArray.length > 0) {
          this.customJobTypeArray = this.customJobTypeArray.filter(item => {
            const customJobType = this.customJobType.find(p => p.code === item)
            return !!customJobType
          })
        }
      }
    },
    onOfficeChange(p) {
      this.officeArray = p.value
      if (!this.officeArray || this.officeArray.length === 0) {
        this.form.onlyApplyBranchAndHq = false
        this.form.onlyApplyDepartmentAndHq = false
      }
    },
    onDepartmentChange(p) {
      this.departmentArray = p.value
      if (!this.departmentArray || this.departmentArray.length === 0) {
        this.form.onlyApplyDepartmentAndHq = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .sop-template-form{
    .el-form-item{
      margin-bottom: 10px !important;
    }
    /deep/.el-checkbox__label{
      color: #666 !important;
    }
    .checkboxGroup /deep/ .el-checkbox__label{
      width: 100px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: -6px;
    }
    .title{
      display: inline-block;
      position: relative;
      font-size: 13px;
      padding-left: 15px;
      line-height: 14px;
      margin-bottom: 10px;
    }
    .title:before {
      content: '';
      position: absolute;
      width: 4px;
      top: 0;
      left: 0;
      bottom: 0;
      background-color: #1F75D5;
    }
  }
</style>
